import { IValidator } from './IValidator';
import { Injectable } from '@angular/core';
import { CollisionService } from '../../../../services/collision/collision.service';

@Injectable()
export class CollisionValidator implements IValidator {
  constructor(private collisionSrvc: CollisionService) {}

  validate(object, newSize, newPosition) {
    const otherObjects = object.parent.children.filter(child => child !== object);
    return (
      this.collisionSrvc.isCollide(object, otherObjects, {
        newSize,
        newPosition
      }) === null
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/Component(2D and 3D)/Shared/ObjectResize/Validators/CollisionValidator.ts